import { LIST_TYPES } from "../utils/listTypes";
import { STRINGS } from "../utils/strings";

import ScrollList from "./ScrollList";
import TextCounter from "./TextCounter";


const ActiveRolesDashFilter = ({
  roleCounts,
  totalCases,
  withRoleAssignmentCount,
  withoutRoleAssignmentCount,
}) => {
  return (
    <div
      id="Active-Roles-Dashboard-Filter"
      data_testid="Active-Roles-Dashboard-Filter"
      className="flex flex-col h-full"
    >
      <div className="h-[74px]" style={{ marginBottom: "10px", paddingRight: "10px" }}>
        <TextCounter
          title={STRINGS.VISIBLE_CASES}
          value={totalCases}
          style={{
            borderBottom: "1px dashed #94A3B8",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        />
        <TextCounter
          title={STRINGS.WITHOUT_ROLE}
          value={withoutRoleAssignmentCount}
          style={{
            borderBottom: "1px dashed #94A3B8",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        />
        <TextCounter
          title={STRINGS.WITH_ROLE}
          value={withRoleAssignmentCount}
          style={{
            borderBottom: "1px dashed #94A3B8",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        />
      </div>
      <div className="border-box h-[70px] overflow-y-auto">
        <ScrollList array={roleCounts} type={LIST_TYPES.TEXT_LIST} />
      </div>
    </div>
  );
};

export default ActiveRolesDashFilter;
